import appDistricts from "../../views/appSettings/districts.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "districts";
  const params = ["page", "limit", "city", "sort"];

  $stateProvider.state("districts", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appDistricts,
      },
    },
    reloadOnSearch: false,
    data: { title: "Districts" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/districts/districts.urls.js